module.exports = __webpack_public_path__ + "img/b2.f4231361.png";